import { Participant } from '../../pages/meeting-view/types/video-types'
import Styles from './UserSkeleton.module.css'

export const UserSkeleton = ({ displayName }: Pick<Participant, 'displayName'>) => (
    <div className={`user ${Styles.skeleton}`}>
        <span>{displayName}</span>
    </div>
)
